import { themedUseStyletron } from '../../../theme/customTheme'
import { Input } from "baseui/input";
import { LabelLarge } from 'baseui/typography';
import { FormControl } from 'baseui/form-control';
import { ILightVar } from './types'
import {  StatefulOperationModeSelect } from '../Aggregate';
import { OperatorPanelWrapper } from '../../components/Layout'
import { OperationState } from "../OperationState";
import { ValueDisplay } from '../../components/ValueDisplay'
import { MdSpeed } from 'react-icons/md'
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormattedMessage } from 'react-intl';
import { FaRegLightbulb } from 'react-icons/fa'

export const OperatorPanel = (props: ILightVar) => {
    const [, theme] = themedUseStyletron();

   const [setPercent, setSetPercent, setSetPercentResult] = useSetObjectValue(props.id, props.resourceGroupId, "setPercent", props.setPercent);
    const onSetPercentChanged = (e: any) => setSetPercent(parseFloat(e.target.value));

    return (
        <OperatorPanelWrapper
            objectId={props.id}
            resourceGroupId={props.resourceGroupId}
            statusContent={
                <>
                    <FaRegLightbulb color={props.isOn ? theme.colors.warning : theme.appColors.aggregate.off} size='40px' />
                    {props.isOn ?
                        <LabelLarge><FormattedMessage id="Devices.ON" defaultMessage="ON" /></LabelLarge>
                        : <LabelLarge color={theme.appColors.aggregate.off}><FormattedMessage id="Devices.OFF" defaultMessage="OFF" /></LabelLarge>
                    }
                    <ValueDisplay value={props.setPercent} dimension='%'></ValueDisplay>
                </>
            }
            operationModeContent={
                <>
                    <StatefulOperationModeSelect {...props}  onSwitchManOff={() => setSetPercent(0)} onSwitchManOn={() => setSetPercent(100)}></StatefulOperationModeSelect>
                    {props.isWriteable && <FormControl
                        label={<FormattedMessage id="Devices.Setpoint" defaultMessage="Setpoint" />}
                        caption={<FormattedMessage id="Devices.EnterSetpoint" defaultMessage="this setpoint is used in manual operation mode" />}
                        error={setSetPercentResult.isError}
                        disabled={setSetPercentResult.isLoading || props.state === OperationState.Auto}
                    >
                        <Input
                            value={setPercent?.toFixed(0)}
                            onChange={onSetPercentChanged}
                            type='number'
                            endEnhancer={''}
                            startEnhancer={<MdSpeed></MdSpeed>}
                        />
                    </FormControl>}
                </>
            }>
        </OperatorPanelWrapper>
    )
}